import React, { useEffect, useState } from "react";
import committeeProfileImg from "../../assets/committeeProfileImg.png";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import axios from "axios";
import { API_URL } from "../../variables";
import { convertBirthTime } from "../../sharedFunctions";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import ProfileDetails from "./profileDetails";
import CancelIcon from "@mui/icons-material/Cancel";
import ImageCarousel from "../shared/imageCarousel/imageCarousel";

const ProfilesTaken = () => {
  const [memberInfo, setMemberInfo] = useState([]);
  const [profile, setProfile] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const [showNoData, setShowNoData] = useState(false);
  useEffect(() => {
    getProfilesTaken();
  }, []);

  const getProfilesTaken = async () => {
    let res = await axios.get(
      API_URL + "profiles_taken?member_id=" + localStorage.getItem("member_id")
    );
    if (res?.data.profiles.length > 0) {
      setMemberInfo(res?.data.profiles);
      setShowNoData(false);
    } else {
      setShowNoData(true);
    }
  };
  return (
    <section className="formSection bg-white mt-4 ">
      <div className="row">
        <div className="col-md-9 p-2">
          {showNoData && (
            <div className="textDarkRed font18px font-bold text-center">
              No data present
            </div>
          )}
          {memberInfo.map((item, index) => {
            return (
              <div key={index}>
                <div className="phoneView">
                  <div className="id p-2 d-flex justify-content-between align-items-center">
                    <label className="textDarkRed mb-0 ">
                      <span>
                        Register No / नोंदणी क्र :
                        <span className="font-bold">
                          {item?.requested_member_details?.member_id?.toUpperCase()}
                          (
                          {item?.requested_member_details?.last_name.toUpperCase()}
                          )
                        </span>
                      </span>
                    </label>
                    <label
                      className="textDarkRed pt-3 hyperLink mr-3"
                      onClick={() => {
                        setProfile(item?.requested_member_details);
                        setShowDetails(true);
                      }}
                    >
                      View Profile
                    </label>
                  </div>
                </div>
                <div className="profileWrapper d-flex justify-content-start mb-3">
                  <div className="w-25">
                    {/* <img
                      alt=""
                      className="profileImg"
                      src={`data:image/jpeg;base64,${item?.requested_member_details?.image1}`}
                    /> */}
                    {item?.requested_member_details?.images && (
                      <ImageCarousel
                        carouselData={item?.requested_member_details?.images}
                      />
                    )}
                  </div>
                  <div className="w-75 profileData">
                    <div>
                      <div className="desktopView">
                        <div className="id p-2 d-flex justify-content-between align-items-center">
                          <label className="textDarkRed mb-0 ">
                            <span>
                              Register No / नोंदणी क्र :
                              <span className="font-bold">
                                {item?.requested_member_details.member_id?.toUpperCase()}
                                (
                                {item?.requested_member_details?.last_name.toUpperCase()}
                                )
                              </span>
                            </span>
                          </label>
                          <label
                            className="textDarkRed pt-3 hyperLink mr-3"
                            onClick={() => {
                              setProfile(item?.requested_member_details);
                              setShowDetails(true);
                            }}
                          >
                            View Profile
                          </label>
                        </div>
                      </div>
                      <div className="details p-1">
                        <div className="row pt-3 p-2">
                          <div className="col-md-4 mb-2">
                            <label className="labelName mb-0">
                              Last Name / आडनाव
                            </label>
                            <label className="textDarkRed font-bold text-capitalize">
                              {item?.requested_member_details?.last_name}
                            </label>
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="labelName mb-0">
                              Date of birth / जन्मतारीख
                            </label>
                            <label className="textDarkRed font-bold">
                              {item?.requested_member_details?.dob}
                            </label>
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="labelName mb-0">
                              Rashi / राशी
                            </label>
                            <label className="textDarkRed font-bold text-capitalize">
                              {item?.requested_member_details?.rashi}
                            </label>
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="labelName mb-0">
                              Birth Time / जन्मस्वेळ
                            </label>
                            <label className="textDarkRed font-bold">
                              {convertBirthTime(
                                item?.requested_member_details?.birth_time
                              )}
                            </label>
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="labelName mb-0">
                              Height / उंची (ft: inch)
                            </label>
                            <label className="textDarkRed font-bold">
                              {item?.requested_member_details?.heightFt} feet{" "}
                              {item?.heightInch} inches
                            </label>
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="labelName mb-0">
                              Education / शिक्षण
                            </label>
                            <label className="textDarkRed font-bold">
                              {item?.requested_member_details?.education.toUpperCase()}
                            </label>
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="labelName mb-0">
                              City /नोकरी शहर
                            </label>
                            <label className="textDarkRed font-bold text-capitalize">
                              {item?.requested_member_details?.city}
                            </label>
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="labelName mb-0">
                              Income / उत्पन्न
                            </label>
                            <label className="textDarkRed font-bold">
                              {item?.requested_member_details?.income_amt}{" "}
                              {item?.income_type}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-md-3 p-3">
          <label className="textDarkRed">
            For more information kindly go through the below videos or contact
            us
          </label>
          <div className="p-2 mb-3">
            <div className="videoContainerImg d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <label className="textDarkRed font18px font-bold">
              How to login
            </label>
          </div>
          <div className="p-2 mb-3">
            <div className="videoContainerImg d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <label className="textDarkRed font18px font-bold">
              How to register yourself
            </label>
          </div>
        </div>
      </div>
      {memberInfo?.length > 0 && (
        <Dialog
          open={showDetails}
          onClose={() => {
            setShowDetails(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="profileDetailsPopup"
        >
          <DialogActions>
            <CancelIcon
              onClick={() => {
                setShowDetails(false);
              }}
              className="cursorPointer"
            />
          </DialogActions>
          <DialogContent className="pt-0">
            <ProfileDetails
              profileData={profile}
              showAllDetailsByDefault={true}
              showGetContactBtn={false}
            />
          </DialogContent>
        </Dialog>
      )}
    </section>
  );
};
export default ProfilesTaken;
